module.exports = __webpack_public_path__ + "img/kn.daaeb98c.svg";